import { styled, Typography } from '@mui/material';
import { DocumentCountDisplayProps } from './types';

const PREFIX = 'DocumentCountDisplay';

const classes = {
  countText: `${PREFIX}-countText`,
};

const Root = styled('div')(() => ({
  [`& .${classes.countText}`]: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const DocumentCountDisplay = ({ currentDocuments }: DocumentCountDisplayProps) => (
  <Root>
    <Typography variant="body2" color="textSecondary" className={classes.countText}>
      {currentDocuments?.files?.length} Document(s) | {currentDocuments?.folders?.length} Subfolder(s)
    </Typography>
  </Root>
);

export default DocumentCountDisplay;
